import React, { Component } from 'react';
import {
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from 'mdbreact';
import { Button } from 'reactstrap'

class Confirmation extends Component {
  state = {
    modal: true
  }

  render() {
    return (
      <MDBContainer>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={() => this.props.deleteMarker()}>Confirm Action!</MDBModalHeader>
          <MDBModalBody>
            {this.props.text}
          </MDBModalBody>
          <MDBModalFooter>
            <Button color="primary" size='sm' onClick={() => this.props.confirm()}>Yes</Button>
            <Button color="primary" outline size='sm' onClick={() => this.props.deleteMarker()} >No</Button>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default Confirmation;


// WEBPACK FOOTER //
// ./src/components/modals/confirmation.js